<template>
  <div id="app" data-server-rendered="true">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import store from "vuex";

import { isPCMobile } from "@/utils/tools";

export default {
  name: "App",
  computed: {
    keepAlive () {
      return this.$route.path;
    }
  },
  watch: {
    "$route": {
      handler (val) {
        // let currentDan = isPCMobile() ? "mobile" : "pc", path = this.$route.path;
        // let pcRouterList = ["/", "/ranking", "/help", "/blacklist", "/dishonesty", "/news", "/newsdetail", "/personCenter"],
        //   mobileRouterList = ["/mobile", "/mobile/ranking", "/mobile/help", "/mobile/blacklist", "/mobile/dishonesty", "/mobile/news", "/mobile/newsdetail", "/mobile/personal"];
        // if (currentDan == "mobile") {
        //   sessionStorage.setItem("facility", "mobile");
        //   let findIndex = pcRouterList.findIndex(ele => ele == path);
        //   if (findIndex != -1 && path != mobileRouterList[findIndex]) {
        //     this.$router.replace(mobileRouterList[findIndex]);
        //   }
        // } else {
        //   sessionStorage.setItem("facility", "pc");
        //   let findIndex = mobileRouterList.findIndex(ele => ele == path);
        //   if (findIndex != -1 && path != pcRouterList[findIndex]) {
        //     this.$router.replace(pcRouterList[findIndex]);
        //   }
        //   if (findIndex == -1 && path.indexOf(mobileRouterList[7]) != -1) {
        //     this.$router.replace("/personCenter");
        //   }
        // }
      },
      deep: true,
      // immediate: true,
    }
  },
  created () {
    let oldTimestamp = localStorage.getItem("time");
    //以前存的时间戳  let login = localStorage.getItem("login");
    let nowTimestamp = new Date().getTime(); //当前时间戳;
    // console.log(oldTimestamp, nowTimestamp, "nowTimestamp");
    // 如果当前时间戳>前面存的时间戳+过期时间 表示已经过期;
    let sumTimestamp = parseInt(oldTimestamp);
    if (oldTimestamp > 0) {
      if (nowTimestamp > sumTimestamp) {
        // console.log("超期");
        this.$store.dispatch("logout");
      }
    }
    if (location.pathname != "/finalize" || location.pathname != "/mobile/share") {
      this.$store.dispatch("startNoticeInterval");
    }
  },
  mounted () {
    if (this._isMobile()) {
      sessionStorage.setItem("facility", "mobile");
      // console.log("手机端");
      // this.$router.replace("/mobile/home");
    } else {
      sessionStorage.setItem("facility", "pc");
      // console.log("pc端");
      // this.$router.replace("/");
      // return;
      // 屏蔽右键
      document.oncontextmenu = new Function("event.returnValue=false")
      document.onkeydown = function (e) {
        // 屏蔽F12
        if (e.keyCode === 123) {
          e.preventDefault()
          e.returnValue = false
          return false
        }
      }
      // 禁用开发者模式
      setInterval(function () {
        function doCheck (a) {
          if (("" + a / a)["length"] !== 1 || a % 20 === 0) {
            (function () { }["constructor"]("debugger")())
          } else {
            (function () { }["constructor"]("debugger")())
          }
          doCheck(++a)
        }
        try {
          doCheck(0)
        } catch (err) { }
      }, 1000);
    }
  },
  methods: {
    // 是否是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
  },
  beforeDestroy () {
    this.$store.dispatch("stopNoticeInterval");
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: "font";
  src: url("@/assets/font/iconfont.woff")format("woff"), url("@/assets/font/iconfont.ttf")format("truetype");
  font-weight: normal;
  font-style: normal;
}

body {
  background-color: #000;
}
</style>
